export default __webpack_public_path__ + "static/media/bitwallet-bdSwiss-light.395392f8.svg";